import API from 'services/api';

export const getCities = () => {
  return API.get('/api/accommodation/objects/cities').then(res => res?.data);
};
